<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:11:16
-->
<template>
  <div>
    <div class="top">
       <div class="search">
           <a-input-group compact>
                <a-select v-model:value="selectName" style="width: 100px;background:#ccc;">
                    <a-select-option @click="selectFn(item.value)" :key="index"  v-for="(item,index) in selectArr">
                        {{item.label}}
                    </a-select-option>
                </a-select>
                <a-input v-model:value="value" placeholder="请输入搜索内容" style="width: 173px" />
            </a-input-group>
            <el-button @click="search" type="primary">查询</el-button>
       </div>
    </div>
    <coententTable  @handleSizeChange="handleSizeChange" :loading="loading" :y="height"  @onShowSizeChange="onShowSizeChange" :columns="columns" :pagination="pagination"  :dataSource="dataSource"></coententTable>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {selectPage} from './user_management' 
export default {
  data() {
    return {
      height:0,
      selectName: "用户姓名",
      selectValue:'1',
      value:'',
      selectArr:[
        {
          label:'用户姓名',
          value:'1',
        },
        {
          label:'手机号',
          value:'2',
        }
      ],
      columns: [
        {
          title: "用户ID",
          dataIndex: "id",
          ellipsis: true,
           customCell: column => {
                            return {
                            style: {
                                'min-width': "120px",
                                'max-width': "300px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "120px",
                                'max-width': "300px",
                            }
                        };
                        }
        },
        {
          title: "用户姓名",
          dataIndex: "name",
          width: 120,
          ellipsis: true,
        },
        {
          title: "手机号",
          dataIndex: "phone",
           width: 120,
          ellipsis: true,
        },
         {
          title: "登录次数",
          dataIndex: "number",
           width: 120,
          ellipsis: true,
        },
         {
          title: "上次登录时间",
          dataIndex: "landTime",
           width: 200,
          ellipsis: true,
        },
        {
          title: "上次登录IP",
          dataIndex: "ip",
           width: 120,
          ellipsis: true,
        },
      ],
       pagination: {
        current:1,
        pageSize:15,
        total:0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      loading:false,
    };
  },
  components:{
    coententTable
  },
  mounted(){
    this.getList();
  },
  methods:{
    // 切换 搜索
    selectFn(value){
        this.selectValue = value;
    },
   onShowSizeChange(current) {
            this.pagination.current = current
            this.getList()
        },
        handleSizeChange(pageSize) {
            this.pagination.pageSize =pageSize
            this.pagination.current = 1
            this.getList()
        },
    search(){
      this.pagination.current = 1;
      this.getList()
    },
    getList(){
      this.loading = true;
      selectPage({
        type:this.selectValue,
        value:this.value,
        current:this.pagination.current,
        size:this.pagination.pageSize,
      }).then((res)=>{
          if(res.code == 0){
              this.dataSource = res.data.records;
              this.pagination.current =  res.data.current;
              this.pagination.total =  res.data.total;
              if(this.pagination.total > 0){
                this.height = document.documentElement.clientHeight - 419;
                window.onresize = () => {
                    return (() => {
                      this.height = document.documentElement.clientHeight - 419;
                    })();
                  };
              }
              this.loading = false;
          }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  //justify-content: right;
  .search{
    display: flex;
    width: 360px;
  }
  /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
}
.el-button--primary {
  background: #176de6;
}
</style>